export const en = {
  referralPage: {
    meta: {
      title: 'Inspired software and fully-coordinated volunteer events',
    },
    header: {
      title: 'Purposely Referral Program',
      subtitle:
        'You get $1,000 and your friend gets 10% off when they choose Purposely',
    },
    howItWorks: {
      title: 'How it works',
      options: {
        sendEmail: {
          title: 'Send an email',
          subtitle:
            "Fill out the form below and send an introdutionary email to potential customers. Make sure to cc eric@purposely.co and we'll take it from there!",
        },
        friendGetsMessage: {
          title: 'Your friend gets the message',
          subtitle:
            "We'll respond to the email, and if the referred customer closes the deal, you'll be eligible for the referral reward.",
        },
        getRewarded: {
          title: 'Get rewarded',
          subtitle:
            "For every successful referral you'll receive $1,000 as a thank you from us!",
        },
      },
    },
    template: {
      title: 'Copy & paste our template to make it easier',
      greeting: "Hi [Friend's Name],",
      paragraph1:
        'Hope you’re doing well! I wanted to reach out in case your company is exploring ways to make employee engagement more impactful through volunteering. Would you forward this message to your VP People or VP Employee Experience to learn about Purposely, and consider it for your org?',
      paragraph2:
        'Here’s a quick blurb you can pass along to anyone who might be interested:',
      paragraph3:
        'Purposely helps companies run structured, high-impact employee volunteer programs without the usual coordination headaches. It’s built for teams to drive real engagement through group volunteering, while tracking participation and impact along the way. Companies like Clio, Boston Dynamics, and GreenShield are already using it to power their programs.',
      links: {
        title: 'A few helpful links:',
        overview: 'Purposely Overview',
        caseStudy: 'Clio Case Study',
      },
      copyButton: 'Copy Text',
      alertSuccess: 'Template copied to clipboard!',
      alertError: 'Failed to copy text. Please try again.',
    },
    termsAndConditions: {
      title: 'Terms and Conditions',
      effectiveDate: 'Effective Date: May 1, 2025',
      terms: [
        'Rewards are issued when a referred organization signs a one-year or longer contract with Purposely.',
        'To qualify, referrals must be initiated via email introduction. Purposely may update or end the referral program at any time without prior notice.',
        'In the event of a dispute, Purposely will determine final eligibility and reward decisions.',
      ],
      contact:
        'If you have any questions about the referral program, feel free to contact Eric at eric@purposely.co.',
    },
  },
}
